import Vue from 'vue'
import Router from 'vue-router'
import websiteIndex from '@/components/websiteIndex/index'
import aboutIndex from '@/components/about/index'
import businessIndex from '@/components/business/index'
import businessOnline from '@/components/business/online'
import businessOffline from '@/components/business/offline'
import talentIndex from '@/components/talent/index'
import collegeIntro from '@/components/college/Intro'
import collegeAdvantages from '@/components/college/advantages'
import seaIndex from '@/components/sea/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'websiteIndex',
      component: websiteIndex
    },
    {
      path: '/about',
      name: 'aboutIndex',
      component: aboutIndex
    },
    {
      path: '/businessIndex',
      name: 'businessIndex',
      component: businessIndex
    },
    {
      path: '/businessOnline',
      name: 'businessOnline',
      component: businessOnline
    },
    {
      path: '/businessOffline',
      name: 'businessOffline',
      component: businessOffline
    },
    {
      path: '/talentIndex',
      name: 'talentIndex',
      component: talentIndex
    },
    {
      path: '/collegeIntro',
      name: 'collegeIntro',
      component: collegeIntro
    },
    {
      path: '/collegeAdvantages',
      name: 'collegeAdvantages',
      component: collegeAdvantages
    },
    {
      path: '/sea',
      name: 'seaIndex',
      component: seaIndex
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js